import type { Image } from '@/types/Image'

export interface ImageSrcsetConfigItem {
  width: number
  height: number
  widthOrDensity: string
}

export type ImageSrcsetConfig = Array<ImageSrcsetConfigItem>

export const getDamImageSrc = (
  damBaseUrlImage: string,
  image: Image | null,
  width: number,
  height: number,
  suffix = ''
): string => {
  if (image === null) return ''

  return (
    damBaseUrlImage +
    'w' +
    width +
    '-h' +
    height +
    (image.dam.regionId > 0 ? '-c' + image.dam.regionId : '') +
    '/' +
    image.dam.damId +
    '.jpg' +
    suffix
  )
}

export const getDamImageSrcSet = (damBaseUrlImage: string, image: Image | null, config: ImageSrcsetConfig): string => {
  if (image === null) return ''
  const sets = []
  for (let i = 0; i < config.length; i++) {
    sets.push(getDamImageSrc(damBaseUrlImage, image, config[i].width, config[i].height, ' ' + config[i].widthOrDensity))
  }

  return sets.join(',')
}
